import { FC } from 'react'
import TreeModal, { ModalStep, ModalHeader } from '@components/modals/TreeModal'
import StartStep from './steps/StartStep'
import UserPermissionsStep from './steps/UserPermissionsStep'
import GroupPermissionsStep from './steps/GroupPermissionsStep'

type ResourcePermissionsModalProps = {
  resourceId: string | number
  resourceType: string
  onClose: () => void
  show: boolean
}

const ResourcePermissionsModal: FC<ResourcePermissionsModalProps> = props => {
  const { resourceId, resourceType, show, onClose } = props

  return (
    <TreeModal show={show} onClose={onClose} initialStepId="start">
      <ModalStep stepId="start" header={<ModalHeader title="Permissions & Access" showBackButton={false} />}>
        <StartStep resourceId={resourceId} resourceType={resourceType} />
      </ModalStep>
      <ModalStep stepId="userPermissions" header={<ModalHeader title="User Access" />}>
        <UserPermissionsStep resourceId={resourceId} resourceType={resourceType} />
      </ModalStep>

      <ModalStep stepId="groupPermissions" header={<ModalHeader title="Group Access" />}>
        <GroupPermissionsStep resourceId={resourceId} resourceType={resourceType} />
      </ModalStep>
    </TreeModal>
  )
}

export default ResourcePermissionsModal
